
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Clock, Star } from "lucide-react";

export function ExpertsEmptyState() {
  return (
    <div className="max-w-4xl mx-auto text-center">
      <Card className="p-8">
        <CardContent className="space-y-6">
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-24 h-24 bg-grandpal-green-light rounded-full flex items-center justify-center">
                <Users className="h-12 w-12 text-grandpal-green-dark" />
              </div>
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                <Star className="h-4 w-4 text-yellow-600" />
              </div>
            </div>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-gray-900">
              Our Expert Marketplace is Launching Soon!
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We're currently onboarding qualified care placement experts to join our marketplace. 
              Our experts will offer personalized consultations on Fair Deal applications, care assessments, 
              and family support services.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-4 mt-8">
            <div className="text-center p-4">
              <div className="w-12 h-12 bg-grandpal-green-light rounded-full flex items-center justify-center mx-auto mb-3">
                <Users className="h-6 w-6 text-grandpal-green-dark" />
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Verified Experts</h4>
              <p className="text-sm text-gray-600">
                All experts go through a rigorous verification process
              </p>
            </div>
            
            <div className="text-center p-4">
              <div className="w-12 h-12 bg-grandpal-green-light rounded-full flex items-center justify-center mx-auto mb-3">
                <Clock className="h-6 w-6 text-grandpal-green-dark" />
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Flexible Booking</h4>
              <p className="text-sm text-gray-600">
                Book consultations at times that work for you
              </p>
            </div>
            
            <div className="text-center p-4">
              <div className="w-12 h-12 bg-grandpal-green-light rounded-full flex items-center justify-center mx-auto mb-3">
                <Star className="h-6 w-6 text-grandpal-green-dark" />
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Quality Assured</h4>
              <p className="text-sm text-gray-600">
                Rated and reviewed by families like yours
              </p>
            </div>
          </div>

          <div className="pt-6">
            <p className="text-sm text-gray-500 mb-4">
              Are you a care placement expert? Join our marketplace
            </p>
            <Button 
              variant="outline" 
              className="mx-auto"
              onClick={() => {
                window.location.href = "/apply-expert";
              }}
            >
              Apply to Become an Expert
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
